const BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:5311/api/v1';
const CLIENT_ID = import.meta.env.VITE_CLIENT_ID ?? 'console';
const CLIENT_VERSION = import.meta.env.VITE_CLIENT_VERSION ?? '0.1.0';

/**
 * Downloads an audit CSV with cookie auth. The shared `api` helper always parses JSON.
 */
export const downloadAuditCsv = async (input: {
  churchId: string;
  query: Record<string, string | number | boolean | undefined | null>;
  fallbackFilename: string;
}): Promise<void> => {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(input.query)) {
    if (value === undefined || value === null || value === '') continue;
    params.set(key, String(value));
  }
  const qs = params.toString();

  const response = await fetch(`${BASE_URL}/audit/logs/export${qs ? `?${qs}` : ''}`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      Accept: 'text/csv',
      'X-Trinity-Client': `${CLIENT_ID}/${CLIENT_VERSION}`,
      'X-Church-Id': input.churchId,
    },
  });

  if (!response.ok) {
    throw new Error(`Export failed (${response.status})`);
  }

  const blob = await response.blob();
  const disposition = response.headers.get('Content-Disposition');
  const match = disposition?.match(/filename="([^"]+)"/);
  const filename = match?.[1] ?? input.fallbackFilename;

  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};
